import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SprintDashboardComponent } from './sprint-dashboard.component';
import { AuthGuardService } from '../../../authentication/auth-guard.service';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';

const routes = [

  // { path: '', redirectTo: 'employees', pathMatch: 'full', canActivate: [AuthGuardService] },
  {
    path: 'sprint-dashboard',
    component: SprintDashboardComponent,
    canActivate: [AuthGuardService],
  },
];
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule
  ]
})
export class SprintDashboardModule { }
